export default __webpack_public_path__ + "static/search-thumbnail-3ba6d1a941f4fe02879feeccee43d715.png";